import { CommonDataService } from './../../../../core/services/common-data.service';
import { OptionsMappingPipe } from './../../../../shared/pipes/options-mapping.pipe';
import { HttpErrorResponse } from '@angular/common/http';
import { getDataScopeByPermission, isNullOrEmpty } from 'src/app/core/utils/common-functions';
import { Component, EventEmitter, Injector, Input, OnInit, Output } from '@angular/core';
import { DeliveryOrderService } from './../../services/delivery-order.service';
import { BookingService } from './../../services/booking.service';
import { SessionBaseComponent } from 'src/app/shared/components/session.base.component';
import { PermissionConstants } from 'src/app/core/constants/permission-constants.constant';

@Component({
  selector: 'laas-do-scan-import',
  templateUrl: './do-scan-import.component.html',
  styleUrls: ['./do-scan-import.component.scss']
})
export class DoScanImportComponent extends SessionBaseComponent implements OnInit {

  readonly permissionCode: PermissionConstants = PermissionConstants.ViewDoScanImport;
  @Input() checkedDOs: any[];
  @Output() DOImported: EventEmitter<any>;
  importDOs: any[];
  waitingReasonOptions: any[];
  noShippingReasonOptions: any[];
  isShowControlledItemModal: boolean;
  isControlledItemList: any;
  selectedCheckBox: any;
  selectedPickingText: any;
  isActive:any;
  @Input() isNeedShowPicking: boolean;

  constructor(
    injector: Injector,
    private DOService: DeliveryOrderService,
    private bookingService: BookingService,
    private commonDataService: CommonDataService,
    private optionsMappingPipe: OptionsMappingPipe,) {
    super(injector);
    this.checkedDOs = [];
    this.DOImported = new EventEmitter<any>();
    this.importDOs = [];
    this.waitingReasonOptions = [];
    this.noShippingReasonOptions = [];
    this.isShowControlledItemModal = false;
    this.isControlledItemList = [];
    this.selectedCheckBox = "0";
    this.selectedPickingText = this.translateService.instant('BookingPreview.DOList.Picking');
    this.isActive = "0";
    this.isNeedShowPicking = false;
  }

  async ngOnInit(): Promise<void> {
    await super.ngOnInit();
    this.commonDataService.getCodeConverter(this.laasSetting.language, 'NoShippingReason', this.laasSetting.facility)
    .subscribe({
      next: (models: any[]) => {
        this.noShippingReasonOptions = models.map(x => ({ label: x.codeDesc, value: x.codeKey }));
      }
    });
    this.commonDataService.getCodeConverter(this.laasSetting.language, 'WaitingReason', this.laasSetting.facility)
      .subscribe({
        next: (models: any[]) => {
          this.waitingReasonOptions = models.map(x => ({ label: x.codeDesc, value: x.codeKey }));
        }
      });
  }

  DOInputEnter(event: any): void {
    const inputValue = event.currentTarget.value;

    if( isNullOrEmpty(inputValue)){
      return;
    }

    if (this.checkedDOs.map(x => x.doNo).indexOf(inputValue) > -1) {
      //已存在
      this.translateService.get('CreateBooking.Alert.AlreadyExist')
            .subscribe({
              next: alreadyExist => {
                this.toastService.warn( inputValue + alreadyExist);
              }
            });

      // this.translateService.get('TransportOperation.Message.DuplicatedDO', { value: inputValue })
      //   .subscribe({
      //     next: msg => {
      //       this.toastService.warn(msg);
      //     }
      //   });
      event.currentTarget.value = '';

      return;
    }

    var dataScopes = getDataScopeByPermission(this.userProfile, this.permissionCode);

    this.DOService.getDeliveryOrderByDONo(this.laasSetting.facility, inputValue, dataScopes)
      .subscribe({
        next: result => {
          const DO = result;
          if (isNullOrEmpty(DO)) {
            //該DO不存在
            this.translateService.get('CreateBooking.Alert.DONotFound')
            .subscribe({
              next: result => {
                this.toastService.warn(result);
              }
            });

            event.target.value = '';
            return;
          }

          DO.reasons = this.getFormatedReasons(DO);
          this.importDOs = [...this.importDOs, DO];
          event.target.value = '';
        },
        error: (error: HttpErrorResponse) => {
          if (error.status === 400) {
            this.toastService.error(error.error);
          }
        }
      });
  }

  selectedPicking(event:any){
    if (this.selectedCheckBox == "0") {
      this.selectedCheckBox = "1";
      this.selectedPickingText = this.translateService.instant('BookingPreview.DOList.NoPicking');
    } else {
      this.selectedCheckBox = "0";
      this.selectedPickingText = this.translateService.instant('BookingPreview.DOList.Picking');
    }
  }

  confirmBtnClick(event: any): void {
    this.DOImported.emit({ originalEvent: event, data: this.importDOs, isActive:this.selectedCheckBox});
  }

  cleanBtnClick(event: any): void {
    this.importDOs = [];
  }

  distinctBtnClick(event: any): void {
    this.importDOs = this.importDOs.reduce((array: any[], item: any) => {
      if (array.findIndex(x => x.doNo === item.doNo) < 0) {
        array.push(item);
      }
      return array;
    }, []);
  }

  private getFormatedReasons(rowData: any): string[] {
    let waitingReasons = (isNullOrEmpty(rowData.waitingReason) ? [] : rowData.waitingReason.split(','))
      .map((x: string) => {
        return this.optionsMappingPipe.transform(x, this.waitingReasonOptions);
      });

    const noShippingReason = this.optionsMappingPipe.transform(rowData.noShippingReason, this.noShippingReasonOptions);
    if (!isNullOrEmpty(noShippingReason)) {
      waitingReasons = waitingReasons.concat(noShippingReason);
    }

    return waitingReasons;
  }

}

